import posthog from "posthog-js";

if (!posthog.__loaded) {
  posthog.init('phc_waj8roiqERr89sNtHkEbc53NRnwnecPr8xoSF3AGf6kZ', {
    api_host: 'https://posthog.convay.com',
    defaults: '2026-05-30',
  });
}

const PostHog = posthog;

export default PostHog;
